<div class="wheel-card" [attr.data-testid]="'wheel-card-' + wheel().id">
  <div class="wheel-card__header">
    <h3 class="wheel-card__name" data-testid="wheel-card-name">
      {{ wheel().name }}
    </h3>
    @if (wheel().categorySnapshots.length) {
      <div class="wheel-card__meta" data-testid="wheel-card-meta">{{ getCategoryCount(wheel()) }} categories</div>
    }
  </div>

  <div class="wheel-card__preview" data-testid="wheel-card-preview">
    <div class="mini-wheel" data-testid="mini-wheel">
      @for (color of getWheelColors(wheel()); track $index) {
        <div
          class="mini-wheel__segment"
          [style.background-color]="color"
          [style.transform]="'rotate(' + $index * (360 / getWheelColors(wheel()).length) + 'deg)'"
          data-testid="mini-wheel-segment"
        ></div>
      }
    </div>
  </div>

  <div class="wheel-card__actions" data-testid="wheel-card-actions">
    <button
      class="wheel-card__action wheel-card__action--primary"
      (click)="onEditWheel()"
      data-testid="wheel-card-edit-button"
      type="button"
      >
      Edit
    </button>
    <button
      class="wheel-card__action wheel-card__action--secondary"
      (click)="onDeleteWheelClick()"
      data-testid="wheel-card-delete-button"
      type="button"
      >
      Delete
    </button>
  </div>
</div>
